module.exports = __webpack_public_path__ + "img/justinmind.149aa59c.svg";